'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: white;\n  width: 100%;\n  height: ', 'px;\n'], ['\n  background-color: white;\n  width: 100%;\n  height: ', 'px;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  align-items: center;\n  width: 100%;\n  background: none;\n  border: none;\n  padding: 0;\n  height:100%;\n  display: inline-flex;\n'], ['\n  align-items: center;\n  width: 100%;\n  background: none;\n  border: none;\n  padding: 0;\n  height:100%;\n  display: inline-flex;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  height: ', 'px;\n  max-width: 115px;\n  width: 50%;\n  position: relative;\n  padding: 0 15px;\n  display:flex;\n  align-items: center;\n'], ['\n  height: ', 'px;\n  max-width: 115px;\n  width: 50%;\n  position: relative;\n  padding: 0 15px;\n  display:flex;\n  align-items: center;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  max-width: 100%;\n  max-height: 100%;\n'], ['\n  max-width: 100%;\n  max-height: 100%;\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  font-size: ', 'em;\n  height: ', 'px;\n  width: 100%;\n  border-bottom: 1px solid ', ';\n  display:flex;\n  align-items: center;\n'], ['\n  font-size: ', 'em;\n  height: ', 'px;\n  width: 100%;\n  border-bottom: 1px solid ', ';\n  display:flex;\n  align-items: center;\n']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n    width:100%;\n'], ['\n    width:100%;\n']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-family: ', ';\n  font-size:  ', 'em;\n  line-height: 18px;\n  text-align: left;\n  padding: 0;\n  margin: 0 0 5px 0;\n  letter-spacing: -0.19px;\n'], ['\n  color: ', ';\n  font-family: ', ';\n  font-size:  ', 'em;\n  line-height: 18px;\n  text-align: left;\n  padding: 0;\n  margin: 0 0 5px 0;\n  letter-spacing: -0.19px;\n']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n  display: block;\n  text-align: left;\n  color: ', ';\n  font-family: ', ';\n  font-size: ', 'em;\n  padding: 0;\n  margin: 0;\n  letter-spacing: 0.05px;\n  line-height: 14px;\n'], ['\n  display: block;\n  text-align: left;\n  color: ', ';\n  font-family: ', ';\n  font-size: ', 'em;\n  padding: 0;\n  margin: 0;\n  letter-spacing: 0.05px;\n  line-height: 14px;\n']),
    _templateObject9 = _taggedTemplateLiteralLoose(['\n  text-align: left;\n  float: left;\n'], ['\n  text-align: left;\n  float: left;\n']),
    _templateObject10 = _taggedTemplateLiteralLoose(['\n  text-align: right;\n  width: 30%;\n  float: right;\n'], ['\n  text-align: right;\n  width: 30%;\n  float: right;\n']),
    _templateObject11 = _taggedTemplateLiteralLoose(['\n  margin-right: 3%;\n  width: 40px;\n'], ['\n  margin-right: 3%;\n  width: 40px;\n']),
    _templateObject12 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n'], ['\n  width: 100%;\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsHelper = require('../../lib/styledComponentsHelper');

var _image = require('../Image/image');

var _image2 = _interopRequireDefault(_image);

var _ADAHelpers = require('../../lib/ADAHelpers');

var _ADAHelpers2 = _interopRequireDefault(_ADAHelpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var getLocalizedText = require('../../localization/CommonLocalizationMixin').functionVersion;


var emBase = 16;
var tileHeight = 110;
var ProductTileStyled = _styledComponents2.default.div(_templateObject, tileHeight);

var ProductTileLink = _styledComponents2.default.div(_templateObject2);

var ImageContainer = _styledComponents2.default.div(_templateObject3, tileHeight);

var ProductImageStyled = (0, _styledComponents2.default)(_image2.default)(_templateObject4);

var TextFlexContainer = _styledComponents2.default.div(_templateObject5, 14 / emBase, tileHeight, _styledComponentsHelper.colors.standard.biege);

var Container = _styledComponents2.default.div(_templateObject6);

var ProductTitleStyled = _styledComponents2.default.p(_templateObject7, _styledComponentsHelper.colors.text.title.brown, _styledComponentsHelper.fonts.bold, 18 / emBase);

var ProductCalorieStyled = _styledComponents2.default.div(_templateObject8, _styledComponentsHelper.colors.text.title.brown, _styledComponentsHelper.fonts.book, 14 / emBase);

var ProductCalorieLeftStyled = _styledComponents2.default.div(_templateObject9);

var ProductCalorieRightStyled = _styledComponents2.default.div(_templateObject10);

var CheckImageContainer = _styledComponents2.default.div(_templateObject11);

var FullWidthImg = _styledComponents2.default.img(_templateObject12);

var ProductTile = function ProductTile(props) {
    var displayName = props.displayName,
        imageUrl = props.imageUrl,
        onClick = props.onClick,
        calories = props.calories,
        altText = props.altText,
        price = props.price,
        lastItemFlag = props.lastItemFlag,
        selectedFlag = props.selectedFlag,
        lang = props.lang,
        cntry = props.cntry,
        _props$buttonProps = props.buttonProps,
        buttonProps = _props$buttonProps === undefined ? {} : _props$buttonProps;


    var caloriesDisplay = '';
    if (calories && price) {
        caloriesDisplay = _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
                ProductCalorieLeftStyled,
                null,
                calories
            ),
            _react2.default.createElement(
                ProductCalorieRightStyled,
                null,
                '$',
                price
            )
        );
    } else if (calories) {
        caloriesDisplay = calories;
    }

    var selectedImage = selectedFlag ? _react2.default.createElement(FullWidthImg, { src: '/images/common/icons/ic_custom_check.png', alt: getLocalizedText('product_tile_selected', false, lang, cntry) }) : '';

    var buttonHelperAttributes = onClick ? { role: 'button', tabIndex: "0", onClick: onClick, onKeyDown: _ADAHelpers2.default.keyupHandler } : {};

    return _react2.default.createElement(
        ProductTileStyled,
        { className: "ProductTileStyled qa-menu-item-container " + props.class || '' },
        _react2.default.createElement(
            ProductTileLink,
            _extends({ className: 'qa-menu-item ' }, buttonHelperAttributes, buttonProps),
            _react2.default.createElement(
                ImageContainer,
                null,
                _react2.default.createElement(
                    Container,
                    null,
                    _react2.default.createElement(ProductImageStyled, { className: 'prod-img', alt: altText, src: imageUrl, backupImage: '/images/common/img_product_placeholder.png', role: !altText ? 'presentation' : 'img' })
                )
            ),
            _react2.default.createElement(
                TextFlexContainer,
                { style: lastItemFlag ? { border: 'none' } : {} },
                _react2.default.createElement(
                    Container,
                    null,
                    _react2.default.createElement(
                        ProductTitleStyled,
                        null,
                        displayName
                    ),
                    _react2.default.createElement(
                        ProductCalorieStyled,
                        { className: 'prod-calories' },
                        caloriesDisplay
                    )
                ),
                _react2.default.createElement(
                    CheckImageContainer,
                    null,
                    selectedImage
                )
            )
        )
    );
};

ProductTile.propTypes = {
    displayName: _propTypes2.default.string,
    imageUrl: _propTypes2.default.string.isRequired,
    linkUrl: _propTypes2.default.string,
    calories: _propTypes2.default.string,
    class: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string
};

exports.default = ProductTile;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/ProductTileMobile/productTileMobile.js
// module id = 317
// module chunks = 0